import React from 'react';
import { CommandMenu } from '@milanote/roma';
import { GridListItem } from 'react-aria-components';

type Props = {
    text: string;
};

const EmptyResultsListItem: React.FC<Props> = ({ text }) => {
    return (
        <GridListItem id="no-results" textValue={text} className="outline-hidden">
            {(state) => (
                <div className="EmptyResultsListItem w-full py-0.5">
                    <CommandMenu.Base.Separator />
                    <CommandMenu.Base.Item
                        isSelected={false}
                        isDisabled={true}
                        isFocused={state.isFocused}
                        isFocusVisible={state.isFocusVisible}
                        isHovered={state.isHovered}
                        className="mx-1.5"
                        size="md"
                    >
                        <span className="truncate text-md text-tertiary">{text}</span>
                    </CommandMenu.Base.Item>
                </div>
            )}
        </GridListItem>
    );
};

export default EmptyResultsListItem;
